module.exports = __webpack_public_path__ + "img/partner05.9fe3af16.png";